import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import * as _ from 'underscore';
import { RootStoreState } from 'src/app/root-store';
import { takeUntil } from 'rxjs/operators';
import { ColumnConfigItem } from 'src/app/models/ColumnConfigItem';

import { getCurrentUser } from 'src/app/root-store/main-app-store/selectors/auth.selector';
import { Product } from 'src/app/models/Product.model';
import { getPagedProductList, getPagedProductListError, getPagedProductListLoading } from 'src/app/root-store/kwikspace-app-store/selectors/product.selector';
import { ClearProductList, GetPagedProductList } from 'src/app/root-store/kwikspace-app-store/actions/product.action';
import { PaginationService } from 'src/app/services/pagination.service';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { getLocations, getLocationsError, getLocationsLoading, getSalesReps, getSalesRepsError, getSalesRepsLoading } from 'src/app/root-store/kwikspace-app-store/selectors/kwikspace.selector';
import { GetLocations, GetSalesReps } from 'src/app/root-store/kwikspace-app-store/actions/kwikspace.action';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailReport } from 'src/app/root-store/kwikspace-app-store/actions/quote.action';
import { getReport, getReportError, getReportLoading } from 'src/app/root-store/kwikspace-app-store/selectors/quote.selector';
import { Report } from 'src/app/models/Report.model';

@Component({
  selector: 'kwikspace-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  locationsLoading$: Observable<any> = this.store.select(getLocationsLoading);
  locationsError$: Observable<any> = this.store.select(getLocationsError);

  repsLoading$: Observable<any> = this.store.select(getSalesRepsLoading);
  repsError$: Observable<any> = this.store.select(getSalesRepsError);

  reportLoading$: Observable<any> = this.store.select(getReportLoading);
  reportError$: Observable<any> = this.store.select(getReportError);

  report: Report;
  reportPeriodDays: number;

  @ViewChild("locations", { static: false })
  locationModal: ModalComponent;

  @ViewChild("reps", { static: false })
  repsModal: ModalComponent;

  locationForm: FormGroup;
  repForm: FormGroup;

  locations: any[] = [];
  reps: any[] = [];

  selectedLocation;
  selectedRep;

  constructor(
    private store: Store<RootStoreState.RootState>,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.locationForm = this.formBuilder.group({
      quote_location: [],
    });
    
    this.repForm = this.formBuilder.group({
      rep: [],
    });

    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getSalesLocations();
          this.getSalesReps();
        }
      });

    this.store
      .select(getReport)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((report: Report) => {
        this.report = report;
        this.reportPeriodDays = this.calculatePeriodDays(report);
      });
  }

  emailReport() {
    this.store.dispatch(new EmailReport());
  }

  // The period is derived from the returned dates rather than the "days"
  // field, as the range is not always the default 30 days.
  calculatePeriodDays(report: Report): number {
    const start = report?.period?.start_date;
    const end = report?.period?.end_date;

    if (!start || !end) {
      return null;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return null;
    }

    const msPerDay = 1000 * 60 * 60 * 24;
    return Math.max(0, Math.round((endDate.getTime() - startDate.getTime()) / msPerDay));
  }

  getSalesLocations() {
    this.store
      .select(getLocations)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((locations: any) => {
        if (locations && locations.results) {
          this.locations = locations.results;
        }
      });

    this.store.dispatch(new GetLocations());
  }

  getSalesReps() {
    this.store.dispatch(
      new GetSalesReps()
    );

    this.store
      .select(getSalesReps)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res?.length > 0) {
          this.reps = res;
        }
      });
  }

  setSelectedQuoteLocation() {
    this.selectedLocation = this.locationForm.value.quote_location;
  }
  
  setSelectedQuoteRep() {
    this.selectedRep = this.repForm.value.rep;
  }

  emailReportByLocation() {
    this.locationModal.open();
  }

  emailReportByRep() {
    this.repsModal.open();
  }

  emailLocationReport() {
    
  }
  
  emailRepReport() {

  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
